/* eslint-disable */
var newAddressBarPath = window.location.pathname
var shortParamsMap = Navigation.shortParamsMap
var longParamMap = Navigation.longParamMap
var defaultParamValues = {
  page: 1,
  limit: boostPFSFilterConfig.general.limit,
  sort: Utils.isSearchPage() ? 'relevance' : Globals.defaultSorting,
  display: Settings.getSettingValue('general.defaultDisplay'),
  tab: Settings.getSettingValue('general.searchPanelDefault')
}

Navigation.buildAddressBarUrl = function (params) {
  var queryParams = params ? params : Globals.queryParams
  var urlPath = window.location.protocol + '//' + window.location.hostname + newAddressBarPath
  var urlQueryString = Utils.getWindowLocation().search
  var urlSearchParams = new URLSearchParams(urlQueryString)
  var hasFilterOptionParam = false
  var urlScheme = Settings.getSettingValue('general.urlScheme')

  // Add & update param values
  Object.keys(queryParams).forEach(key => {
    var value = queryParams[key]

    // Filter params
    if (key.startsWith(Globals.prefix)) {
      // Get the short url param key
      var shortKey = shortParamsMap.get(key)
      if (!shortKey) shortKey = key

      urlSearchParams.delete(shortKey)
      if (Array.isArray(value)) {
        // Build urlSearchParams by urlScheme
        switch (urlScheme) {
          case 0:
            // Don't build filter params
            break
          case 2:
            // Example: color=red,blue
            if (value.length > 0) {
              value = value.map(function (item) {
                if (item.indexOf(shortKey) !== -1) {
                  return item.replace(shortKey + ': ', '').trim()
                }
              })
            }
            urlSearchParams.set(shortKey, value)
            break
          case 1:
          default:
            // Example: color=red&color=blue
            value.forEach(singleValue => {
              urlSearchParams.append(shortKey, singleValue)
            })
            break
        }
        hasFilterOptionParam = true
      } else if (typeof value !== 'undefined' && value !== null) {
        urlSearchParams.set(shortKey, value)
        hasFilterOptionParam = true
      }

      // Search query param
    } else if (key == Globals.searchTermKey && typeof value == 'string') {
      urlSearchParams.set(key, value)

      // Other params: page, limit, display, sort: remove these params if they're at default value
    } else if (Globals.otherParams.includes(key)) {
      if (value == defaultParamValues[key] || (key == 'sort' && value == Globals.defaultSorting)) {
        urlSearchParams.delete(key)
      } else {
        urlSearchParams.set(key, value)
      }
    }
  })

  // Remove non-existing params values
  var keysToBeRemoved = []
  urlSearchParams.forEach((value, key) => {
    var longKey = longParamMap.get(key)
    if (!longKey) longKey = key
    if (
      longKey.startsWith(Globals.prefix) ||
      Globals.imutableFilterTree.includes(longKey) ||
      longKey == Globals.searchTermKey
    ) {
      if (!queryParams.hasOwnProperty(longKey)) {
        keysToBeRemoved.push(key)
      }
    }
  })
  keysToBeRemoved.forEach(key => {
    urlSearchParams.delete(key)
  })

  Globals.hasFilterOptionParam = hasFilterOptionParam

  // Uncomment to add "_=pf" param
  // Globals.hasFilterOptionParam = hasFilterOptionParam;
  // if (hasFilterOptionParam) {
  // 	urlSearchParams.set('_', Globals.prefix);
  // } else {
  // 	urlSearchParams.delete('_');
  // }

  // Sort key/values
  urlSearchParams.sort()

  // Get string
  var url = urlPath
  var queryString = urlSearchParams.toString()
  if (queryString) {
    if (urlScheme == 2) {
      queryString = queryString.replace(/%2C/g, ',')
    }
    url += '?' + queryString
  }

  return url
}

var newWindowTitle = document.title
Navigation.updateAddressBar = function () {
  if (
    Settings.getSettingValue('general.urlScheme') == 0 ||
    !window.history ||
    typeof window.history.pushState != 'function'
  )
    return
  var newUrl = Navigation.buildAddressBarUrl()

  // Remove functions from query params
  var cleanQueryParams = JSON.parse(JSON.stringify(Globals.queryParams))
  Globals.queryParams = cleanQueryParams

  // Save to  history
  history.pushState(
    {
      param: Globals.queryParams
    },
    newWindowTitle,
    newUrl
  )
  currentUrl = newUrl

  const event = new Event('boost-pfs-change-address-bar')
  window.dispatchEvent(event)
}

// Not hide products with specific tags
//FilterApi.beforeCall = function () {
//  var currentPathname = window.location.pathname
// If collection archive => show all products except for those with tag "refill"
// if (currentPathname.indexOf('collections/archive') != -1) {
//    Globals.queryParams['pf_t_tag'] = ['not_refill']
// If collection refills => show all products except for those with tag "hide"
// } else if (currentPathname.indexOf('collections/refills') != -1) {
//   Globals.queryParams['pf_t_tag'] = ['not_hide']
// If not collection refills & archive => Hide products with tag "hide" & "refill"
//  } else {
//    Globals.queryParams['pf_t_tag'] = ['not_hide', 'not_refill']
//    Globals.queryParams.pf_t_tag_and_condition = true
//  }
//}

// Not hide products with specific tags
FilterApi.beforeCall = function () {
  if (boostPFSConfig.general.collection_handle != 'travel-size-skincare') {
    // Globals.queryParams['pf_t_tag'] = ['not_travel']
    console.log('_____________NOT_______________')
  }
  // Start #183015
  Object.keys(Globals.queryParams).forEach(queryParam => {
    if (queryParam.startsWith(Globals.prefix)) {
      let newPrefix = queryParam.split('_t_')
      let newPrefixValue = newPrefix[1]
      let oldParamValues = Globals.queryParams[queryParam]
      let newPatamValues = []
      let detectPrefix = ''
      switch (newPrefixValue) {
        case 'hauttypen':
          detectPrefix = 'skin_type:'
          break
        case 'hautzustand':
          detectPrefix = 'skin_concern:'
          break
        case 'unbedenklich_fuer':
          detectPrefix = 'safe_for:'
          break
        case 'schluesselwirkstoff':
          detectPrefix = 'key_ingredient:'
          break
        case 'ziel':
          detectPrefix = 'goal:'
          break
        case 'produktart':
          detectPrefix = 'product_type:'
          break
        default:
          detectPrefix = ''
        // code block
      }
      for (let paramValue of oldParamValues) {
        if (detectPrefix !== '' && !paramValue.includes(detectPrefix)) {
          paramValue = detectPrefix + ' ' + paramValue
          newPatamValues.push(paramValue)
        }
      }
      if (newPatamValues.length > 0) {
        Globals.queryParams[queryParam] = newPatamValues
      }
    }
  })
  // End #183015
}
